import LogoSvg from "../../assets/svgs/logo.svg";
import styles from "./SplashScreen.module.css";

/**
 * Full-screen brand splash shown while the initial auth check is in flight,
 * i.e. before useAuthStore.isInitialized turns true. Rendered by the route
 * guards so neither the login page nor a blank screen flashes on cold load.
 */
export const SplashScreen = () => (
  <div className={styles.splash} role="status" aria-label="Wird geladen">
    <img src={LogoSvg} alt="WGH" className={styles.logo} />
  </div>
);
